import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import "../Borrower/AddBorrower/AddBorrower.css";
import TextField from "@mui/material/TextField";
import { IconButton, InputAdornment, MenuItem } from "@mui/material";
import { AiOutlineTable } from "react-icons/ai";
import Button from "@mui/material/Button";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "../../Sidebar/Sidebar";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { url } from "../../App";
import Cookies from "js-cookie";
import { useBorrowerContext } from "../Borrower/BorrowerDetails/store/borrower-details";
import { useLocation, useParams } from "react-router-dom";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { useNavigate } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const NewEditLoan = () => {
  const navigate = useNavigate();
  const [uploadedDocs, setUploadedDocs] = useState({});
  const { loanid } = useParams();
  const { state } = useLocation();
  // const [profession, setProfession] = useState("");
  const [loanProduct, setLoanProduct] = useState("");
  const [loanAmount, setLoanAmount] = useState("");
  const [loanTenure, setLoanTenure] = useState("");
  const [open, setOpen] = React.useState(false);
  const [loanProductData, setLoanProductData] = useState([]);
  const token = Cookies.get("Token");
  const email = Cookies.get("Email");
  const [isOpen, setIsOpen] = useState(true);
  const openView = (val) => setIsOpen(val);
  const [templateData, setTemplateData] = useState(null);
  const [formValues, setFormValues] = useState({});
  const [apiDropdowns, setApiDropdowns] = useState({});
  // eslint-disable-next-line
  const [negativeArea, setNegativeArea] = useState({});
  const [loanData, setLoanData] = useState(null);
  const { borrowerData } = useBorrowerContext();
  const borrower = borrowerData.borrower;
  const [visible, setvisible] = useState(false);
  const [companyIdVisible, setCompanyIdVisible] = useState(false);
  // const [branchIdVisible, setBranchIdVisible] = useState(false);
  // const [sourceIdVisible, setSourceIdVisible] = useState(false);
  const [companyData, setCompanyData] = useState([]);
  const [branchData, setBranchData] = useState([]);
  const [sourceData, setsourceData] = useState([]);
  const [companyIdSuperadmin, setCompanyIdSuperadmin] = useState("");
  const [branchIdSuperadmin, setBranchIdSuperadmin] = useState("");
  const [sourceIdSuperadmin, setsourceIdSuperadmin] = useState("");
  const [branchNameSuperadmin, setBranchNameSuperadmin] = useState("");
  const [sourceNameSuperadmin, setsourceNameSuperadmin] = useState("");
  const [sameAddress, setSameAddress] = useState(false);
  const [sameBank, setSameBank] = useState(true);
  const [showEncrypted, setShowEncrypted] = useState({});
  const [dropdownLoanObj, setDropdownLoanObj] = useState({
    loanCount: 0,
    repeatCheck: true,
    topupCheck: true,
    topupbtCheck: true,
    restructureCheck: true,
    checkNew: true
  });
  const [loanType, setLoanType] = useState("");
  const [addDocumentPermission, setAddDocumentPermission] = useState(false);
  const documentSections = [
    "Basic Documents",
    "Current Address Documents",
    "Bank Documents",
    "Income Documents",
    "Employement Documents",
    "Business Documents",
    "Other Documents"
  ];
  const [isDisbursed, setIsDisbursed] = useState(false);

  const handleToggleVisibility = (id) => {
    setShowEncrypted((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  // console.log(companyData, branchData, sourceData)
  useEffect(() => {
    axios
      .post(url + "/loanproduct/dropdownarray", {
        token: token,
        email: email,
      })
      .then((res) => {
        if (res.data.auth === false) {
          // toast.dismiss("custom");
        } else {
          // console.log(res.data);
          setLoanProductData(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [token, email]);


  useEffect(() => {
    axios
      .post(url + "/loan/previous/loan/check", {
        token,
        email,
        borrowerUniqueNo: borrower.borrower_uniqueno
      })
      .then((res) => {
        const data = res.data.data;
        setDropdownLoanObj(data);
      });
  }, [token, email, state, navigate, borrower]);

  useEffect(() => {
    axios
      .post(url + "/loan/getsingle", {
        token: token,
        email: email,
        loan_id: loanid
      })
      .then((res) => {
        const data = res.data[0];
        // console.log("API loan data:", data);
        if (!data) return;
        setLoanData(data);
        setIsDisbursed(data.loan_status === "DISBURSED");
        // setProfession(data?.loan_professiontype);
        setLoanProduct(data?.loanproduct_id);
        setLoanAmount(data?.loan_principal_amt);
        setLoanTenure(data?.loan_duration);
        setLoanType(data?.loan_type);
        const docsMap = buildUploadedDocsFromLoan(data);
        setUploadedDocs(docsMap);
        setCompanyIdSuperadmin(data?.loan_companycode);
        setBranchIdSuperadmin(data?.loan_branchcode);
        setsourceIdSuperadmin(data?.loan_sourcecode);
        setBranchNameSuperadmin(data?.loan_branchname);
        setsourceNameSuperadmin(data?.sourceNameSuperadmin);
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.message);
      });
  }, [token, email, loanid]);

  // useEffect(() => {
  //   if (!templateData?.fields || !loanData) return;

  //   // const apiDynamic = loanData || loanData?.dynamic_data || {};
  //   const apiDynamic = loanData?.dynamic_data || loanData || {};
  //   const filledValues = {};

  //   templateData.fields.forEach((section) => {
  //     section.fields.forEach((field) => {
  //       if (field.type !== "file") {
  //         filledValues[field.id] = apiDynamic[field.id] || "";
  //       }
  //     });
  //   });

  //   setFormValues(filledValues);
  // }, [templateData, loanData]);

  useEffect(() => {
    if (!templateData?.fields || !loanData) return;

    const filledValues = {};

    templateData.fields.forEach((section) => {
      section.fields.forEach((field) => {
        if (field.type === "file") return;

        if (
          section.section_name === "Reference Details" &&
          (field.id.startsWith("reference_") ||
            field.id.startsWith("relationship_with_applicant_"))
        ) {
          const parts = field.id.split("_");
          const index = Number(parts[parts.length - 1]) - 1;
          const baseKey = parts.slice(0, -1).join("_");

          filledValues[field.id] =
            loanData?.reference_details?.[index]?.[baseKey] ?? "";
        } else if (section.section_name === "Applicant Family Details" && (field.id.startsWith("name_") ||
          field.id.startsWith("age_") || field.id.startsWith("relationship_") || field.id.startsWith("occupation_") ||
          field.id.startsWith("phone_"))) {
          const parts = field.id.split("_");
          const index = Number(parts[parts.length - 1]) - 1;
          const baseKey = parts.slice(0, -1).join("_");

          filledValues[field.id] =
            loanData?.family_details?.[index]?.[baseKey] ?? "";
        } else {
          filledValues[field.id] =
            loanData?.[field.id] ??
            loanData?.dynamic_data?.[field.id] ??
            "";
        }
      });
    });

    setFormValues(filledValues);

    const currentKeys = Object.keys(filledValues).filter(k =>
      k.startsWith("current_")
    );

    if (currentKeys.length > 0) {
      const allMatch = currentKeys.every(currentKey => {
        const permanentKey = currentKey.replace("current_", "permanent_");

        return (
          filledValues[currentKey] &&
          filledValues[currentKey] === filledValues[permanentKey]
        );
      });
      console.log(allMatch, "formvalues")
      setSameAddress(allMatch);
    }

    const collectionKeys = Object.keys(filledValues).filter(k =>
      k.startsWith("collection_")
    );

    if (collectionKeys.length > 0) {
      const allBankMatch = collectionKeys.every(collectionKey => {
        const disbursementKey = collectionKey.replace(
          "collection_",
          "disbursement_"
        );

        return filledValues[collectionKey] === filledValues[disbursementKey];
      });

      setSameBank(allBankMatch);
    }

  }, [templateData, loanData]);

  useEffect(() => {
    if (!templateData) return;

    axios.post(url + "/company/dropdownarray", {
      token,
      email
    })
      .then(res => {
        const list = Array.isArray(res?.data) ? res.data : [];
        if (list.length === 0) toast.error("Company not found.");
        setCompanyData(
          list.map(item => ({
            company_id: item.company_id,
            company_name: item.company_name,
            is_active: item.is_active
          }))
        );
      });

    axios.post(url + "/branch/companytobranch", {
      company_id: companyIdSuperadmin,
      token,
      email
    }).then(res => {
      // console.log(res.data)
      const list = Array.isArray(res?.data?.message) ? res.data.message : [];
      if (list.length === 0) toast.error("Branch not found.");
      setBranchData(
        list.map(item => ({
          branch_id: item.branch_id,
          branch_name: item.branch_name,
          is_active: item.is_active
        }))
      );
    });

    axios.post(url + "/user/branchtouser", {
      staff_branch: branchIdSuperadmin,
      token,
      email
    }).then(res => {
      const list = Array.isArray(res?.data?.message) ? res.data.message : [];
      if (list.length === 0) toast.error("User not found.");
      setsourceData(
        list.map(item => ({
          staff_id: item.staff_id,
          staff_name: item.staff_name,
          is_active: item.is_active
        }))
      );
    });

    // eslint-disable-next-line
  }, [templateData, state, token, email]);

  useEffect(() => {
    if (!loanData) return;

    if (
      loanData?.current_pincode &&
      loanData.current_pincode.length === 6
    ) {
      fetchPincodeData(loanData.current_pincode, "current");
    }

    if (
      loanData?.permanent_pincode &&
      loanData.permanent_pincode.length === 6
    ) {
      fetchPincodeData(loanData.permanent_pincode, "permanent");
    }

    //eslint-disable-next-line
  }, [loanData]);

  useEffect(() => {
    if (!loanData) return;

    if (
      loanData?.current_pincode &&
      loanData?.current_sub_district
    ) {
      fetchLocalityDropdown(
        loanData.current_sub_district,
        "current"
      );
    }

    if (
      loanData?.permanent_pincode &&
      loanData?.permanent_sub_district
    ) {
      fetchLocalityDropdown(
        loanData.permanent_sub_district,
        "permanent"
      );
    }

    //eslint-disable-next-line
  }, [loanData]);

  useEffect(() => {
    if (!formValues.company_id) return;

    const fetchBranches = async () => {
      try {
        const res = await axios.post(url + "/branch/companytobranch", {
          company_id: formValues.company_id,
          token,
          email
        });

        const list = Array.isArray(res?.data?.message) ? res.data.message : [];
        if (list.length === 0) toast.error("Branch not found.");

        setBranchData(prev => ({
          ...prev,
          branch_id: list.map(item => ({
            label: item.branch_name,
            value: item.branch_id
          }))
        }));

      } catch (err) {
        console.log(err);
        toast.error("Failed to fetch branches");
      }
    };

    fetchBranches();
  }, [formValues?.company_id, token, email]);

  useEffect(() => {
    if (!formValues.branch_id) return;

    const fetchSource = async () => {
      try {
        const res = await axios.post(url + "/user/branchtouser", {
          staff_branch: formValues.branch_id,
          token,
          email
        });

        const list = Array.isArray(res?.data?.message) ? res.data.message : [];
        if (list.length === 0) toast.error("User not found.");

        setsourceData(prev => ({
          ...prev,
          source_code: list.map(item => ({
            label: item.user_name || item.staff_name,
            value: item.staff_id
          }))
        }));
      } catch (err) {
        console.log(err);
        toast.error("Failed to fetch source users");
      }
    };

    fetchSource();
  }, [formValues?.branch_id, token, email]);

  useEffect(() => {
    if (!loanData || !loanProductData.length) return;

    const selectedProduct = loanProductData.find(
      (item) => item.loanproduct_id === loanData.loanproduct_id
    );

    if (selectedProduct?.template_id) {
      fetchTemplate(selectedProduct.template_id);
    }
    // eslint-disable-next-line
  }, [loanData, loanProductData]);

  const handleLoanProductChange = (selectedLoanProductId) => {
    setLoanProduct(selectedLoanProductId);

    const selectedProduct = loanProductData.find((item) => item.loanproduct_id === selectedLoanProductId);

    if (selectedProduct) {
      fetchTemplate(selectedProduct.template_id);
    }
  };

  const fetchTemplate = (templateId) => {
    axios
      .post(url + "/template/getsingle", {
        token,
        email,
        template_id: templateId,
      })
      .then((res) => {
        // console.log("TEMPLATE API RAW RESPONSE:", res.data);
        if (Array.isArray(res.data) && res.data.length > 0) {
          const template = res.data[0];

          template.fields = template.fields.map(section => {

            if (section.section_name === "Address Details") {
              const currentFields = section.fields.filter(f => f.id.startsWith("current"));
              const permanentFields = section.fields.filter(f => f.id.startsWith("permanent"));

              return {
                ...section,
                fields: [...currentFields, ...permanentFields]
              };
            }

            if (section.section_name === "Bank Details") {

              const sortBankFields = (fields, prefix) => {
                const priorityOrder = [
                  `${prefix}_bank_ifsc`,
                  `${prefix}_bank_name`,
                  `${prefix}_bank_branch`
                ];

                const priority = [];
                const others = [];

                fields.forEach(field => {
                  if (priorityOrder.includes(field.id)) {
                    priority.push(field);
                  } else {
                    others.push(field);
                  }
                });

                priority.sort(
                  (a, b) => priorityOrder.indexOf(a.id) - priorityOrder.indexOf(b.id)
                );

                return [...priority, ...others];
              };

              const collectionFields = section.fields.filter(f =>
                f.id.startsWith("collection")
              );

              const disbursementFields = section.fields.filter(f =>
                f.id.startsWith("disbursement")
              );

              return {
                ...section,
                fields: [
                  ...sortBankFields(collectionFields, "collection"),
                  ...sortBankFields(disbursementFields, "disbursement")
                ]
              };
            }

            return section;
          });

          setTemplateData(template);
          // console.log("TEMPLATE SET:", res.data[0]);
        } else {
          console.log("Unexpected template format", res.data);
        }
      })
      .catch((err) => {
        console.log("fetchTemplate error:", err);
      });
  };

  const handleInputChange = (id, value) => {
    setFormValues(prev => {
      const updated = { ...prev, [id]: value };

      if (sameAddress && id.startsWith("current_")) {
        const permanentId = id.replace("current_", "permanent_");
        updated[permanentId] = value;
      }

      if (id.startsWith("permanent_")) {
        const currentId = id.replace("permanent_", "current_");
        if (updated[currentId] !== value) {
          setSameAddress(false);
        }
      }

      if (sameBank && id.startsWith("collection_")) {
        const disbursementId = id.replace("collection_", "disbursement_");
        updated[disbursementId] = value;
      }

      if (id.startsWith("disbursement_")) {
        const collectionId = id.replace("disbursement_", "collection_");
        if (updated[collectionId] !== value) {
          setSameBank(false);
        }
      }

      return updated;
    });

    if (id.endsWith("bank_ifsc")) {

      const prefix = id.split("_")[0];

      if (value.length === 11) {
        fetchBankDetails(value, prefix);
      } else {
        setFormValues(prev => {
          const updated = {
            ...prev,
            [`${prefix}_bank_name`]: "",
            [`${prefix}_bank_branch`]: ""
          };

          if (sameBank && prefix === "collection") {
            updated["disbursement_bank_name"] = "";
            updated["disbursement_bank_branch"] = ""
          }

          return updated;
        });
      }
    }


    if (id.endsWith("pincode")) {

      const prefix = id.split("_")[0];

      if (value.length === 6) {
        fetchPincodeData(value, prefix);
      }
    }

  };

  const fetchBankDetails = async (ifsc, prefix) => {
    try {
      const res = await axios.post(`${url}/api/fetch/bank/details`, {
        IFSC: ifsc,
        token,
        email
      });

      if (res.data.success) {
        toast.success("Bank Details Found");

        setFormValues(prev => {
          const updated = {
            ...prev,
            [`${prefix}_bank_name`]: res.data.bank,
            [`${prefix}_bank_branch`]: res.data.branch
          };

          if (sameBank && prefix === "collection") {
            updated["disbursement_bank_name"] = res.data.bank;
            updated["disbursement_bank_branch"] = res.data.branch;
          }

          return updated;
        });

      } else {
        toast.error(res.data.message);

        setFormValues(prev => {
          const updated = {
            ...prev,
            [`${prefix}_bank_name`]: "",
            [`${prefix}_bank_branch`]: ""
          };

          if (sameBank && prefix === "collection") {
            updated["disbursement_bank_name"] = "";
            updated["disbursement_bank_branch"] = ""
          }

          return updated;
        });

      }

    } catch (err) {
      console.log(err);
      toast.error("Failed to fetch bank details");

      setFormValues(prev => {
        const updated = {
          ...prev,
          [`${prefix}_bank_name`]: "",
          [`${prefix}_bank_branch`]: ""
        };

        if (sameBank && prefix === "collection") {
          updated["disbursement_bank_name"] = "";
          updated["disbursement_bank_branch"] = ""
        }

        return updated;
      });
    }
  };

  const fetchPincodeData = async (pincode, prefix) => {
    try {
      const res = await axios.get(`${url}/pincode/${pincode}`, {
        headers: { token, email }
      });

      if (res.data.Status === "Success") {
        // toast.success(res.data.Message);

        const subDistrictArray = res.data.subDistricts || [];
        const subDistrictOptions = subDistrictArray.map(sd => ({
          label: sd,
          value: sd
        }));

        setFormValues(prev => {
          const updated = {
            ...prev,
            [`${prefix}_state`]: res.data.State,
            [`${prefix}_city`]: res.data.District
          };

          const isSameAddress =
            prev.current_address === prev.permanent_address &&
            prev.current_pincode === prev.permanent_pincode;

          if (prefix === "current" && isSameAddress && !loanData) {
            updated["permanent_state"] = res.data.State;
            updated["permanent_city"] = res.data.District;
          }

          return updated;
        });

        setApiDropdowns(prev => {
          const updated = {
            ...prev,
            [`${prefix}_sub_district`]: subDistrictOptions
          };

          const isSameAddress =
            formValues.current_address === formValues.permanent_address &&
            formValues.current_pincode === formValues.permanent_pincode;

          if (prefix === "current" && isSameAddress && !loanData) {
            updated["permanent_sub_district"] = subDistrictOptions;
          }

          return updated;
        });

      } else {
        toast.error(res.data.Message);
        clearAddressDependencies(prefix);
      }

    } catch (err) {
      console.log(err);
      clearAddressDependencies(prefix);
    }
  };

  const clearAddressDependencies = (prefix) => {
    setFormValues(prev => ({
      ...prev,
      [`${prefix}_state`]: "",
      [`${prefix}_city`]: "",
      [`${prefix}_sub_district`]: "",
      [`${prefix}_locality`]: ""
    }));

    setApiDropdowns(prev => {
      const updated = {
        ...prev,
        [`${prefix}_sub_district`]: [],
        [`${prefix}_locality`]: []
      };

      const isSameAddress =
        formValues.current_address === formValues.permanent_address &&
        formValues.current_pincode === formValues.permanent_pincode;

      if (prefix === "current" && isSameAddress && !loanData) {
        updated["permanent_sub_district"] = [];
        updated["permanent_locality"] = [];
      }

      return updated;
    });

  };

  const handleSelectApiChange = (fieldId, value) => {
    handleInputChange(fieldId, value);

    if (fieldId === "company_id") {
      setFormValues(prev => ({
        ...prev,
        branch_id: "",
        source_code: ""
      }));
    }

    if (fieldId === "branch_id") {
      setFormValues(prev => ({
        ...prev,
        source_code: ""
      }));
    }

    if (fieldId === "current_sub_district" || fieldId === "permanent_sub_district") {
      setFormValues(prev => ({
        ...prev,
        locality: ""
      }));
    }

    if (fieldId === "company_id") {
      axios
        .post(url + "/branch/companytobranch", { company_id: value, token, email })
        .then(res => {
          const list = Array.isArray(res?.data?.message) ? res.data.message : [];
          if (list.length === 0) {
            toast.error("Branch not found.");
          }
          setApiDropdowns(prev => ({
            ...prev,
            branch_id: list.map(item => ({ label: item.branch_name, value: item.branch_id }))
          }));
        })
        .catch(err => console.log(err));
    }

    if (fieldId === "branch_id") {
      axios
        .post(url + "/user/branchtouser", {
          staff_branch: value,
          token,
          email
        })
        .then(res => {
          const list = Array.isArray(res?.data?.message) ? res.data.message : [];
          if (list.length === 0) {
            toast.error("User not found.");
          }
          setApiDropdowns(prev => ({
            ...prev,
            source_code: list.map(item => ({ label: item.staff_name, value: item.staff_id }))
          }));
        })
        .catch(err => console.log(err));
    }
    if (fieldId === "current_sub_district") {
      fetchLocalityDropdown(value, "current");
    }

    if (fieldId === "permanent_sub_district") {
      fetchLocalityDropdown(value, "permanent");
    }

    if (fieldId === "current_locality") {
      checkNegativeAreaDynamic(value, "current");
    }

    if (fieldId === "permanent_locality") {
      checkNegativeAreaDynamic(value, "permanent");
    }

  };

  const fetchLocalityDropdown = async (subDistrict, prefix) => {
    try {
      const pincode = formValues[`${prefix}_pincode`] || loanData[`${prefix}_pincode`];
      if (!pincode) return;

      const res = await axios.get(
        `${url}/pincode/${pincode}/${subDistrict}`,
        {
          headers: { token, email }
        }
      );
      const localityArr = res.data.locality || [];

      const localityOptions = localityArr.map(l => ({
        label: l,
        value: l
      }));
      setApiDropdowns(prev => {
        const updated = {
          ...prev,
          [`${prefix}_locality`]: localityOptions
        };
        const isSameAddress =
          formValues.current_address === formValues.permanent_address &&
          formValues.current_pincode === formValues.permanent_pincode;

        if (prefix === "current" && isSameAddress && !loanData) {
          updated["permanent_locality"] = localityOptions;
        }

        return updated;
      });

    } catch (err) {
      console.log(err);
      toast.error(err.message);
    }
  };

  const checkNegativeAreaDynamic = async (locality, prefix) => {
    try {
      const res = await axios.get(
        `${url}/pincode/negativearea/${locality}`,
        {
          headers: { token, email }
        }
      );

      if (res.data.Status === "Error") {
        return toast.error(res.data.message);
      }

      setNegativeArea(prev => {
        const updated = {
          ...prev,
          [`${prefix}_locality`]: res.data.negativeArea
        };
        const isSameAddress =
          formValues.current_address === formValues.permanent_address &&
          formValues.current_pincode === formValues.permanent_pincode;

        if (prefix === "current" && isSameAddress && !loanData) {
          updated["permanent_locality"] =
            res.data.negativeArea;
        }

        return updated;
      });

    } catch (err) {
      console.log(err);
    }
  };

  const handleUpdateSection = async () => {
    // console.log(formValues, "formValues")
    // console.log(templateData, "formValues")
    const dynamic_formValues = {};

    templateData.fields.forEach((section) => {
      section.fields.forEach((field) => {
        if (field.custom === true && formValues.hasOwnProperty(field.id)) {
          dynamic_formValues[field.id] = formValues[field.id];
        }
      });
    });

    // console.log(dynamic_formValues, "formValues");

    const allowedReferencePrefixes = [
      "reference_name_",
      "reference_number_",
      "reference_address_",
      "relationship_with_applicant_",
    ];

    const reference_details = Object.keys(formValues)
      .filter((key) =>
        allowedReferencePrefixes.some((prefix) => key.startsWith(prefix))
      )
      .reduce((acc, key) => {
        const match = key.match(/_(\d+)$/);
        if (!match) return acc;

        const index = match[1];

        if (!acc[index]) {
          acc[index] = {
            reference_name: "",
            reference_number: "",
            reference_address: "",
            relationship_with_applicant: "",
          };
        }

        if (key.startsWith("reference_name_"))
          acc[index].reference_name = formValues[key];

        if (key.startsWith("reference_number_"))
          acc[index].reference_number = formValues[key];

        if (key.startsWith("reference_address_"))
          acc[index].reference_address = formValues[key];

        if (key.startsWith("relationship_with_applicant_"))
          acc[index].relationship_with_applicant = formValues[key];

        return acc;
      }, {});

    const allowedFamilyPrefixes = [
      "name_",
      "relationship_",
      "age_",
      "occupation_",
      "phone_",
    ];

    const family_details = Object.keys(formValues)
      .filter((key) =>
        allowedFamilyPrefixes.some((prefix) => key.startsWith(prefix))
      )
      .reduce((acc, key) => {
        const match = key.match(/_(\d+)$/);
        if (!match) return acc;

        const index = match[1];

        if (!acc[index]) {
          acc[index] = {
            name: "",
            relationship: "",
            age: "",
            occupation: "",
            phone: "",
          };
        }

        if (key.startsWith("name_"))
          acc[index].name = formValues[key];

        if (key.startsWith("relationship_"))
          acc[index].relationship = formValues[key];

        if (key.startsWith("age_"))
          acc[index].age = formValues[key];

        if (key.startsWith("occupation_"))
          acc[index].occupation = formValues[key];

        if (key.startsWith("phone_"))
          acc[index].phone = formValues[key];

        return acc;
      }, {});

    if (
      formValues.collection_bank_account_number &&
      formValues.collection_confirm_bank_account_number &&
      formValues.collection_bank_account_number !==
      formValues.collection_confirm_bank_account_number
    ) {
      toast.error(
        "Collection Bank Account Number and Confirm Bank Account Number should be same."
      );
      return;
    }

    if (
      formValues.disbursement_bank_account_number &&
      formValues.disbursement_confirm_bank_account_number &&
      formValues.disbursement_bank_account_number !==
      formValues.disbursement_confirm_bank_account_number
    ) {
      toast.error(
        "Disbursement Bank Account Number and Confirm Bank Account Number should be same."
      );
      return;
    }

    try {
      setOpen(true);
      const payload = {
        borrower_uniqueno: borrower.borrower_uniqueno,
        loanproduct_id: loanProduct,
        loan_id: loanid,
        dynamic_data: dynamic_formValues,
        // marital_status: formValues?.marital_status,
        // residence_type: formValues?.residence_type,
        // family_structure: formValues?.family_structure,
        // total_family_members: formValues?.total_family_members,
        // current_address: formValues?.current_address,
        // current_pincode: formValues?.current_pin_code,
        // current_state: formValues?.current_state_name,
        // current_city: formValues?.current_city_name,
        // current_sub_district: formValues?.current_sub_district,
        // current_locality: formValues?.current_locality_village,
        // current_landmark: formValues?.current_landmark,
        // current_residing_since: formValues?.current_residing_since_in_years,
        // permanent_address: formValues?.permanent_address,
        // permanent_pincode: formValues?.permanent_pin_code,
        // permanent_state: formValues?.permanent_state_name,
        // permanent_city: formValues?.permanent_city_name,
        // permanent_sub_district: formValues?.permanent_sub_district,
        // permanent_locality: formValues?.permanent_locality_village,
        // permanent_landmark: formValues?.permanent_landmark,
        // permanent_residing_since: formValues?.permanent_residing_since_in_years,
        // collection_bank_ifsc: formValues?.collection_bank_search_by_ifsc,
        // collection_bank_name: formValues?.collection_bank_name,
        // collection_bank_branch: formValues?.collection_bank_branch,
        // collection_bank_type: formValues?.collection_bank_type,
        // collection_bank_account_number: formValues?.collection_bank_account_number,
        // collection_beneficiary_name: formValues?.collection_beneficiary_name,
        // disbursement_bank_ifsc: formValues?.disbursement_bank_search_by_ifsc,
        // disbursement_bank_name: formValues?.disbursement_bank_name,
        // disbursement_bank_branch: formValues?.disbursement_bank_branch,
        // disbursement_bank_type: formValues?.disbursement_bank_type,
        // disbursement_bank_account_number: formValues?.disbursement_bank_account_number,
        // disbursement_beneficiary_name: formValues?.disbursement_beneficiary_name,
        // nature_of_business: formValues?.nature_of_employer,
        // employer_name: formValues?.employer_name,
        // business_type: formValues?.business_type,
        // department: formValues?.department,
        // designation: formValues?.designation,
        // current_employer_duration: formValues?.duration_with_employer_months,
        // total_work_duration: formValues?.total_work_experience_in_months,
        // salary_mode: formValues?.salary_mode,
        // current_salary: formValues?.current_salary_monthly,
        // previous_salary: formValues?.previous_salary_monthly,
        // office_number: formValues?.office_number,
        // office_hr_number: formValues?.office_hr_number,
        // dateofJoining: formValues?.date_of_joining,
        // employeeCode: formValues?.employee_code,
        // office_industry: formValues?.industry,
        // office_sector: formValues?.sector,
        // office_subsector: formValues?.subsector,
        // business_name: formValues?.business_name_mandli_name_center_name,
        // secretary_name: formValues?.mantri_sachiv_secretary_name,
        // secretary_number: formValues?.mantri_sachiv_secretary_number,
        // income_mode: formValues?.income_mode,
        // business_income_monthly: formValues?.business_income_monthly,
        // business_phone_number: formValues?.business_phone_number,
        // business_email: formValues?.business_email,
        // business_experience_months: formValues?.number_of_years_in_business_in_months,
        // total_work_experience_months: formValues?.total_work_experience_in_months,
        // legal_status: formValues?.legal_status,
        // business_ids: formValues?.business_ids,
        // office_type: formValues?.office_type,
        // office_size_sqft: formValues?.office_size_sqft,
        // number_of_employees: formValues?.number_of_employees,
        reference_details: Object.values(reference_details),
        family_details: Object.values(family_details),
        // date_of_marriage: formValues?.date_of_marriage,
        // spouse_name: formValues?.spouse_name,
        loan_companycode: companyIdSuperadmin,
        loan_branchcode: branchIdSuperadmin,
        loan_sourcecode: sourceIdSuperadmin,
        loan_branchname: branchNameSuperadmin,
        loan_sourcename: sourceNameSuperadmin,
        token,
        email,
        loan_principal_amt: loanAmount,
        loan_duration: loanTenure,
        loan_type: loanType,
        ...formValues
      };

      const res = await axios.post(url + "/loan/updatenew", payload);

      if (res.data.auth) {
        toast.success(res.data.message);
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      console.log(err);
      toast.error("Update failed");
    } finally {
      setOpen(false);
    }
  };

  const handleFileUpload = async (docName, file) => {
    try {
      setOpen(true);
      if (!file) {
        setOpen(false);
        return;
      }

      let doc_type = file.name.split(".").pop();
      const allowed = ["jpg", "jpeg", "png", "pdf", "xlsx"];

      if (!allowed.includes(doc_type)) {
        setOpen(false);
        toast.error("Only JPG, PNG, JPEG, PDF or Excel files allowed");
        return;
      }

      if (doc_type === "jpg") doc_type = "jpeg";

      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = async (ev) => {
        const base64Data = ev.target.result.split(",").pop();
        const payload = {
          borrower_uniqueno: borrower.borrower_uniqueno,
          loan_id: loanid,
          doc_name: docName,
          doc_type: doc_type,
          fileName: base64Data,
          token,
          email,
        };

        const res = await axios.post(url + "/loan/adddoc", payload);
        if (!res.data.auth) {
          toast.error(res.data.message);
          setOpen(false);
          return;
        }
        toast.success(res.data.message);
        setUploadedDocs((prev) => ({
          ...prev,
          [docName]: (prev[docName] || 0) + 1,
        }));
        setOpen(false);
        return;
      };
    } catch (err) {
      console.error(err);
      setOpen(false);
      toast.error("Upload failed");
      return;
    }
  };

  const validateRequiredFields = () => {
    if (!templateData?.fields) return true;

    for (const section of templateData.fields) {
      for (const field of section.fields) {

        if (!field.required) continue;

        // FILE FIELD
        if (field.type === "file") {
          if (!uploadedDocs[field.doc_name]) {
            toast.error(`${field.label} is required`);
            return false;
          }
        }

        // MULTI SELECT / CHECKBOX
        else if (field.type === "multi_select" || field.type === "checkbox") {
          const value = formValues[field.id];
          if (!Array.isArray(value) || value.length === 0) {
            toast.error(`${field.label} is required`);
            return false;
          }
        }

        // ALL OTHER INPUTS
        else {
          const value = formValues[field.id];
          if (
            value === undefined ||
            value === null ||
            value === ""
          ) {
            toast.error(`${field.label} is required`);
            return false;
          }
        }
      }
    }

    return true;
  };

  const handleToggleLoanStatus = async () => {
    const isValid = validateRequiredFields();
    if (!isValid) return;

    try {
      setOpen(true);
      const payload = {
        loan_id: loanid,
        token,
        email,
      };

      const res = await axios.post(url + "/loan/completestatus", payload);

      if (res.data.auth) {
        toast.success(res.data.message);
        setTimeout(() => {
          // navigate("/borrower/view");
          window.location.reload();
        }, 3000);
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      console.error(err);
      toast.error("Update failed");
    } finally {
      setOpen(false);
    }
  };

  const buildUploadedDocsFromLoan = (loan) => {
    const map = {};

    Object.entries(loan).forEach(([key, value]) => {
      if (
        typeof value !== "object" ||
        value === null ||
        ["_id", "__v"].includes(key)
      ) {
        return;
      }

      if (Array.isArray(value) && value.length > 0) {
        map[key] = value.length;
      }

      else if (value.location && value.doc_name) {
        map[key] = 1;
      }
    });

    return map;
  };

  const handleCompanyId = (event) => {
    // setCompanyIdSuperadmin(event.target.value);
    // setBranchIdSuperadmin("");
    // console.log(event.target.value);

    const a = companyData.filter((value) => {
      // console.log(value)
      return value.company_id === event.target.value;
    });

    setCompanyIdSuperadmin(a[0].company_id);

    axios
      .post(url + "/branch/companytobranch", {
        company_id: a[0].company_id,
        token: token,
        email: email,
      })
      .then((res) => {
        // console.log(res);
        if (res.data.auth === false) {
          toast.error("Branch is not found.");
          setBranchData("");
        } else {
          // console.log(res.data);
          setBranchData(res?.data.message);
        }
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  console.log(companyIdSuperadmin, branchIdSuperadmin, sourceIdSuperadmin)

  const handleBranchId = (event) => {
    // setBranchIdSuperadmin(event.target.value);
    // setsourceIdSuperadmin("");
    // console.log(event.target.value);

    const b = branchData.filter((value) => {
      // console.log(value)
      return value.branch_id === event.target.value;
    });

    setBranchIdSuperadmin(b[0].branch_id);
    setBranchNameSuperadmin(b[0].branch_name);

    axios
      .post(url + "/user/branchtouser", {
        staff_branch: b[0].branch_id,
        token: token,
        email: email,
      })
      .then((res) => {
        // console.log(res);
        if (res.data.auth === false) {
          toast.error("User is not found.");
          setsourceData("");
        } else {
          setsourceData(res?.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (email === "rupesh.bishnoi@credin.in") {
      setvisible(true);
      setAddDocumentPermission(true);
    } else {
      axios
        .post(url + "/user/getsingle", {
          token: token,
          email: email,
          useremail: email
        })
        .then((res) => {
          // console.log(res);
          setCompanyIdVisible(res.data[0].permission.company_branch_source_mapping);
          setAddDocumentPermission(res.data[0].permission.add_loan_application_document);
          // setBranchIdVisible(res.data[0].permission.borrower_branch_id);
          // setSourceIdVisible(res.data[0].permission.borrower_source_id);
        })
        .catch((err) => {
          // console.log(err);
          toast.error(err.message);
        })
    };
    // eslint-disable-next-line
  }, [token, email]);

  // console.log(templateData, "templateData")

  // const isFieldDisabled = (sectionName, fieldId) => {
  //   return (
  //     (sectionName === "Address Details" &&
  //       sameAddress &&
  //       fieldId.startsWith("permanent_")) ||

  //     (sectionName === "Bank Details" &&
  //       sameBank &&
  //       fieldId.startsWith("disbursement_"))
  //   );
  // };

  const isFieldDisabled = (sectionName, fieldId) => {
    // const isAddressOrBank =
    //   sectionName === "Address Details" ||
    //   sectionName === "Bank Details";

    if (sectionName === "Other Documents") {
      return false;
    }
    
    const sectionCondition =
      (sectionName === "Address Details" &&
        sameAddress &&
        fieldId.startsWith("permanent_")) ||

      (sectionName === "Bank Details" &&
        sameBank &&
        fieldId.startsWith("disbursement_"));

    return sectionCondition || isDisbursed;
  };

  return (
    <>
      <div style={{ height: "20px" }} />
      <Sidebar click={openView} />
      <div style={{ marginLeft: isOpen ? "15%" : "0", transition: "all 0.2s" }}>
        <div className="main-container">
          <div className="content-container">
            <h2 className="main-heading">
              <AiOutlineTable />
              Edit New Loan
            </h2>
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-8">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">
                Basic Loan Details
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                {/* <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Loan Profession Type<span className="text-red-500">*</span>
                  </label>
                  <TextField
                    select
                    name="profession-type"
                    value={profession}
                    onChange={(e) => setProfession(e.target.value)}
                    size="small"
                    className="w-full"
                    variant="outlined"
                  >
                    <MenuItem value="">Select Profession Type</MenuItem>
                    <MenuItem value="SALARIED">SALARIED</MenuItem>
                    <MenuItem value="SELF-EMPLOYED">SELF EMPLOYED</MenuItem>
                  </TextField>
                </div> */}

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Loan Product<span className="text-red-500">*</span>
                  </label>
                  <TextField
                    select
                    name="loan-product"
                    value={loanProduct}
                    onChange={(e) => handleLoanProductChange(e.target.value)}
                    size="small"
                    className="w-full"
                    variant="outlined"
                    disabled={isDisbursed}
                  >
                    {loanProductData?.map((loanProductData, id2) => (
                      <MenuItem key={id2} value={loanProductData.loanproduct_id} disabled={!loanProductData.is_active || isDisbursed}>
                        {loanProductData.loanproduct_name}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Loan Amount<span className="text-red-500">*</span>
                  </label>
                  <TextField
                    type="number"
                    className="w-full"
                    size="small"
                    name="loan-amount"
                    value={loanAmount}
                    onChange={(e) => setLoanAmount(e.target.value)}
                    placeholder="Enter Loan Amount"
                    variant="outlined"
                    disabled
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Loan Tenure (in Months)<span className="text-red-500">*</span>
                  </label>
                  <TextField
                    select
                    name="loan-tenure"
                    value={loanTenure}
                    onChange={(e) => setLoanTenure(e.target.value)}
                    size="small"
                    className="w-full"
                    variant="outlined"
                    disabled
                  >
                    <MenuItem value="1">1 Month</MenuItem>
                    <MenuItem value="12">12 Months</MenuItem>
                    <MenuItem value="24">24 Months</MenuItem>
                    <MenuItem value="36">36 Months</MenuItem>
                    <MenuItem value="48">48 Months</MenuItem>
                    <MenuItem value="60">60 Months</MenuItem>
                    <MenuItem value="120">120 Months</MenuItem>
                    <MenuItem value="180">180 Months</MenuItem>
                    <MenuItem value="240">240 Months</MenuItem>
                  </TextField>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Loan Type<span className="text-red-500">*</span>
                  </label>
                  <TextField
                    className="input-field-add-loan"
                    select
                    name="loan-type"
                    variant="outlined"
                    value={loanType}
                    size="small"
                    onChange={(e) => setLoanType(e.target.value)}
                    disabled={isDisbursed}
                  >
                    <MenuItem value="">Select Loan Type</MenuItem>
                    <MenuItem disabled={!dropdownLoanObj.checkNew} value="NEW">NEW</MenuItem>
                    <MenuItem disabled={!dropdownLoanObj.repeatCheck} value="REPEAT">REPEAT</MenuItem>
                    <MenuItem disabled={!dropdownLoanObj.topupCheck} value="TOPUP">TOPUP</MenuItem>
                    <MenuItem disabled={!dropdownLoanObj.topupbtCheck} value="TOPUP + BT">TOPUP + BT</MenuItem>
                  </TextField>
                </div>
              </div>
              <div className="btns-add-borrower">
                <Button
                  onClick={handleUpdateSection}
                  variant="contained"
                  type="submit"
                  disabled={isDisbursed}
                  style={{ marginRight: "1rem" }}>
                  Update Loan
                </Button>
              </div>
            </div>

            <div className="container-add-borrower">
              <div className="fields-add-borrower">
                <h3 className="text-base font-semibold text-gray-800 mb-4">
                  Additional Loan Application Details
                </h3>

                {templateData?.fields?.filter(
                  (section) =>
                    addDocumentPermission ||
                    !documentSections.includes(section.section_name)
                )?.map((section, index) => (
                  <Accordion key={index} className="menu-item-add-borrower">
                    <AccordionSummary aria-controls="panel1a-content" id="panel1a-header">
                      <p style={{ fontWeight: "bold" }}>{section.section_name}</p>
                    </AccordionSummary>

                    <AccordionDetails className="personal-details">
                      {section.section_name === "Address Details" && (
                        <div style={{ gridColumn: "1 / -1", marginBottom: "15px" }}>
                          <label>
                            <input
                              type="checkbox"
                              checked={sameAddress}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                setSameAddress(checked);

                                if (checked) {
                                  setFormValues(prev => {
                                    const updated = { ...prev };

                                    Object.keys(prev).forEach(key => {
                                      if (key.startsWith("current_")) {
                                        const permanentKey = key.replace("current_", "permanent_");
                                        updated[permanentKey] = prev[key];
                                      }
                                    });

                                    return updated;
                                  });

                                  setApiDropdowns(prev => ({
                                    ...prev,
                                    permanent_sub_district: prev.current_sub_district || [],
                                    permanent_locality: prev.current_locality || []
                                  }));
                                }
                              }}
                              style={{ marginRight: "8px" }}
                            />
                            Current Address and Permanent Address are same
                          </label>
                        </div>
                      )}

                      {section.section_name === "Bank Details" && (
                        <div style={{ gridColumn: "1 / -1", marginBottom: "15px" }}>
                          <label>
                            <input
                              type="checkbox"
                              checked={sameBank}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                setSameBank(checked);

                                if (checked) {
                                  setFormValues(prev => {
                                    const updated = { ...prev };

                                    Object.keys(prev).forEach(key => {
                                      if (key.startsWith("collection_")) {
                                        const disbursementKey = key.replace(
                                          "collection_",
                                          "disbursement_"
                                        );
                                        updated[disbursementKey] = prev[key];
                                      }
                                    });

                                    return updated;
                                  });
                                }
                              }}
                              style={{ marginRight: "8px" }}
                            />
                            Collection Bank and Disbursement Bank are same
                          </label>
                        </div>
                      )}

                      {section.fields.map((field) => (
                        <div key={field.id} className="input-item">

                          <label>
                            {field.label}
                            {field.required && <span style={{ color: "red" }}>*</span>}
                          </label>
                          <br />

                          {field.type === "text" && (
                            <TextField
                              className="input-field"
                              size="small"
                              value={formValues[field.id] || ""}
                              onChange={(e) => handleInputChange(field.id, e.target.value)}
                              disabled={isFieldDisabled(section.section_name, field.id)}
                            />
                          )}

                          {field.type === "date" && (
                            <TextField
                              className="input-field"
                              type="date"
                              size="small"
                              value={
                                formValues?.[field.id]
                                  ? formValues[field.id].split("T")[0]
                                  : ""
                              }
                              onChange={(e) =>
                                handleInputChange(field.id, e.target.value)
                              }
                              InputLabelProps={{ shrink: true }}
                              disabled={isFieldDisabled(section.section_name, field.id)}
                              inputProps={{
                                max: new Date().toISOString().split("T")[0],
                              }}
                            />
                          )}

                          {field.type === "number" && (
                            <TextField
                              className="input-field"
                              type="number"
                              size="small"
                              value={formValues[field.id] || ""}
                              onChange={(e) => handleInputChange(field.id, e.target.value)}
                              disabled={isFieldDisabled(section.section_name, field.id)}
                            />
                          )}

                          {field.type === "email" && (
                            <TextField
                              className="input-field"
                              type="email"
                              size="small"
                              value={formValues[field.id] || ""}
                              onChange={(e) => handleInputChange(field.id, e.target.value)}
                              disabled={isFieldDisabled(section.section_name, field.id)}
                            />
                          )}

                          {field.type === "encrypted" && (
                            <TextField
                              className="input-field"
                              type={showEncrypted[field.id] ? "text" : "password"}
                              size="small"
                              value={formValues[field.id] || ""}
                              onChange={(e) => handleInputChange(field.id, e.target.value)}
                              disabled={isFieldDisabled(section.section_name, field.id)}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      onClick={() => handleToggleVisibility(field.id)}
                                      edge="end"
                                    >
                                      {showEncrypted[field.id] ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          )}

                          {field.type === "file" && (
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "auto 50px",
                                alignItems: "flex-start",
                                marginBottom: "14px",
                                columnGap: "12px"
                              }}
                            >
                              {/* LEFT */}
                              <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                <input
                                  type="file"
                                  className="input-field"
                                  onChange={(e) => {
                                    const doc_name = field.doc_name || field.id;
                                    handleFileUpload(doc_name, e.target.files[0])
                                  }}
                                  disabled={isFieldDisabled(section.section_name, field.id)}
                                />
                              </div>

                              {/* RIGHT */}
                              {uploadedDocs[field.doc_name] && (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    marginTop: "4px",
                                  }}
                                >
                                  <TaskAltIcon style={{ color: "green" }} />

                                  {uploadedDocs[field.doc_name] > 1 && (
                                    <span style={{ fontSize: "12px", color: "#555" }}>
                                      {uploadedDocs[field.doc_name]}
                                    </span>
                                  )}
                                </div>
                              )}
                            </div>
                          )}

                          {field.type === "select" && (
                            <TextField
                              className="input-field"
                              select
                              size="small"
                              value={formValues[field.id] || ""}
                              onChange={(e) => handleInputChange(field.id, e.target.value)}
                              disabled={isFieldDisabled(section.section_name, field.id)}
                            >
                              {field.options
                                ?.filter(opt => opt.selected === true)
                                .map((opt) => (
                                  <MenuItem key={opt.value} value={opt.value}>
                                    {opt.label}
                                  </MenuItem>
                                ))}
                            </TextField>
                          )}

                          {field.type === "select-api" && (
                            <TextField
                              className="input-field"
                              select
                              size="small"
                              value={formValues[field.id] || ""}
                              onChange={(e) => handleSelectApiChange(field.id, e.target.value)}
                              disabled={isFieldDisabled(section.section_name, field.id)}
                            >
                              <MenuItem value="">Select</MenuItem>
                              {apiDropdowns[field.id]?.map((opt) => (
                                <MenuItem key={opt.value} value={opt.value} disabled={opt.disabled}>
                                  {opt.label}
                                </MenuItem>
                              ))}
                            </TextField>
                          )}

                          {field.type === "multi_select" && (
                            <TextField
                              className="input-field"
                              select
                              multiple
                              size="small"
                              value={formValues[field.id] || []}
                              onChange={(e) =>
                                handleInputChange(
                                  field.id,
                                  Array.from(e.target.value)
                                )
                              }
                              disabled={isFieldDisabled(section.section_name, field.id)}
                            >
                              {field.options
                                ?.filter(opt => opt.selected === true)
                                .map((opt) => (
                                  <MenuItem key={opt.value} value={opt.value}>
                                    {opt.label}
                                  </MenuItem>
                                ))}
                            </TextField>
                          )}

                          {field.type === "radio" && (
                            <div className="flex">
                              {field.options
                                ?.filter(opt => opt.selected === true)
                                .map((opt) => (
                                  <label key={opt.value} style={{ marginRight: "1rem" }}>
                                    <input
                                      type="radio"
                                      name={field.id}
                                      value={opt.value}
                                      checked={formValues[field.id] === opt.value}
                                      onChange={(e) =>
                                        handleInputChange(field.id, e.target.value)
                                      }
                                      disabled={isFieldDisabled(section.section_name, field.id)}
                                    />
                                    {opt.label}
                                  </label>
                                ))}
                            </div>
                          )}

                          {field.type === "checkbox" && (
                            <div className="flex">
                              {field.options
                                ?.filter(opt => opt.selected === true)
                                .map((opt) => {
                                  const checkedValues = formValues[field.id] || [];
                                  return (
                                    <label key={opt.value} style={{ marginRight: "1rem" }}>
                                      <input
                                        type="checkbox"
                                        value={opt.value}
                                        checked={checkedValues.includes(opt.value)}
                                        onChange={(e) => {
                                          const updated = e.target.checked
                                            ? [...checkedValues, opt.value]
                                            : checkedValues.filter((v) => v !== opt.value);
                                          handleInputChange(field.id, updated);
                                        }}
                                        disabled={isFieldDisabled(section.section_name, field.id)}
                                      />
                                      {opt.label}
                                    </label>
                                  );
                                })}
                            </div>
                          )}

                        </div>
                      ))}

                    </AccordionDetails>

                    {!(
                      documentSections.includes(section.section_name) &&
                      section.section_name !== "Bank Documents" &&
                      section.fields.some((field) => field.type === "file")
                    ) && (
                        <div className="btns-add-borrower">
                          <Button
                            onClick={() => handleUpdateSection()}
                            variant="contained"
                            color="success"
                            style={{ marginRight: "1rem" }}
                            disabled={
                              isDisbursed
                            }
                          >
                            Update
                          </Button>
                        </div>
                      )}
                  </Accordion>
                ))}

                <Accordion className="menu-item-add-borrower">
                  <AccordionSummary aria-controls="panel1a-content" id="panel1a-header">
                    <p style={{ fontWeight: "bold" }}>Mapping Details</p>
                  </AccordionSummary>

                  <AccordionDetails className="personal-details">
                    {/* {(companyIdVisible || visible) && ( */}
                    <div className="input-item">
                      <label>Company Id*</label>
                      <TextField
                        name="company-id"
                        className="input-field"
                        select
                        size="small"
                        onChange={handleCompanyId}
                        value={companyIdSuperadmin}
                        disabled={(!companyIdVisible && !visible) || isDisbursed}
                      >
                        {companyData.length > 0 &&
                          companyData.map((data, id) => (
                            <MenuItem
                              key={id}
                              value={data.company_id}
                              disabled={!data.is_active}
                            >
                              {data.company_id + " " + data.company_name}
                            </MenuItem>
                          ))}
                      </TextField>
                    </div>
                    {/* )} */}
                    {/* {(branchIdVisible || visible) && ( */}
                    <div className="input-item">
                      <label>Branch Id*</label>
                      <TextField
                        name="branch-id"
                        className="input-field"
                        select
                        size="small"
                        // onChange={(e) =>
                        //   setBranchIdSuperadmin(e.target.value)
                        // }
                        onChange={handleBranchId}
                        value={branchIdSuperadmin}
                        disabled={(!companyIdVisible && !visible) || isDisbursed}
                      >
                        {branchData.length > 0 &&
                          branchData.map((data, id) => (
                            <MenuItem
                              key={id}
                              value={data.branch_id}
                              disabled={!data.is_active}
                            >
                              {data.branch_id + " " + data.branch_name}
                            </MenuItem>
                          ))}
                      </TextField>
                    </div>
                    {/* )} */}
                    {/* {(sourceIdVisible || visible) && ( */}
                    <div className="input-item">
                      <label>Source Code*</label>
                      <TextField
                        name="source-id"
                        className="input-field"
                        select
                        size="small"
                        onChange={(e) => {
                          const selectedId = e.target.value;

                          setsourceIdSuperadmin(selectedId);

                          const selectedStaff = sourceData.find(
                            (item) => String(item.staff_id) === String(selectedId)
                          );

                          if (selectedStaff) {
                            setsourceNameSuperadmin(selectedStaff.staff_name);
                          }
                        }}
                        value={sourceIdSuperadmin}
                        disabled={(!companyIdVisible && !visible) || isDisbursed}
                      >
                        {sourceData.length > 0 &&
                          sourceData.map((data, id) => (
                            <MenuItem
                              key={id}
                              value={data.staff_id}
                              disabled={!data.is_active}
                            >
                              {data.staff_id + " " + data.staff_name}
                            </MenuItem>
                          ))}
                      </TextField>
                    </div>

                    {/* )} */}
                  </AccordionDetails>
                  <div className="btns-add-borrower">
                    <Button
                      onClick={() => handleUpdateSection()}
                      variant="contained"
                      color="success"
                      style={{ marginRight: "1rem" }}
                      disabled={(!companyIdVisible && !visible) || isDisbursed}
                    >
                      Update
                    </Button>
                  </div>
                </Accordion>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "right",
                  }}
                >
                  <Button
                    onClick={handleToggleLoanStatus}
                    variant="contained"
                    disabled={isDisbursed}
                  >
                    Submit
                  </Button>
                </div>

              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </>
  );
}

export default NewEditLoan;